exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes DownloadIcon-fadeinout{0%{height:0}to{height:100%}}.DownloadIcon-default-4UL1I{display:inline-block;position:relative}.DownloadIcon-progress-1rCpF{position:absolute;left:3px;right:3px;bottom:3px;opacity:.5;background:#00e5ce;animation:DownloadIcon-fadeinout 3s linear infinite}", ""]);

// exports
exports.locals = {
	"default": "DownloadIcon-default-4UL1I",
	"progress": "DownloadIcon-progress-1rCpF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/DownloadIcon.less
// module id = 1646
// module chunks = 0